export default __webpack_public_path__ + "static/media/51.8421c8fb.svg";